import { Component } from 'react';
import { connect } from 'react-redux';

import withTrackingPropsProvider from '../../../hocs/withTrackingPropsProvider';

class PlatformContentSwitcher extends Component {
  render() {
    const { isMobile, mobile, desktop } = this.props;

    return isMobile ? mobile : desktop;
  }
}

const mapStateToProps = ({ env }) => ({
  isMobile: env.isMobile,
});

export default connect(mapStateToProps)(
  withTrackingPropsProvider(PlatformContentSwitcher),
);
